export default __webpack_public_path__ + "static/media/graphicDesign.360e2430.png";